import type { DocumentNode } from 'graphql';

import Urls from 'src/config/routes';
import {
  GetSavedListingsDocument,
  GetSavedSearchesDocument,
  GetUserDocument,
} from 'src/generated/graphql';

export const mapRouteToQuery = (route: string): DocumentNode => {
  switch (route) {
    case Urls.PROFILE_SAVED_BUSINESSES:
      return GetSavedListingsDocument;
    case Urls.PROFILE_SAVED_SEARCHES:
      return GetSavedSearchesDocument;
    default:
      return GetUserDocument;
  }
};
